export const PURPLEZONE_SERVER_ID_KEY = 'pzsid';

export const PURPLEZONE_CHARACTER_ID_KEY = 'pzcid';